var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeGuidance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2498)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 75,
    fill: "#EDF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5 104C104.684 104 81 109.85 81 121.5V129C81 131.75 83.2821 134 86.0714 134H146.929C149.718 134 152 131.75 152 129V121.5C152 109.85 128.316 104 116.5 104Z",
    fill: "#4F75FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5 92C44.025 92 9 100.775 9 118.25V129.5C9 133.625 12.375 137 16.5 137H106.5C110.625 137 114 133.625 114 129.5V118.25C114 100.775 78.975 92 61.5 92Z",
    fill: "#4F75FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 54.5C84 66.95 74.0084 77 61.5376 77C49.0668 77 39 66.95 39 54.5C39 42.05 49.0668 32 61.5376 32C74.0084 32 84 42.05 84 54.5Z",
    fill: "#4F75FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 78C132 86.3 125.117 93 116.526 93C107.935 93 101 86.3 101 78C101 69.7 107.935 63 116.526 63C125.117 63 132 69.7 132 78Z",
    fill: "#4F75FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.875 112.25H85.125V152.75H37.875V112.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.875 105.5H31.125C27.4125 105.5 24.375 108.537 24.375 112.25V152.75C24.375 156.463 27.4125 159.5 31.125 159.5H91.875C95.5875 159.5 98.5912 156.463 98.5912 152.75L98.625 112.25C98.625 108.537 95.5875 105.5 91.875 105.5ZM85.125 152.75H37.875V112.25H85.125V152.75Z",
    fill: "#4F75FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 68 118)",
    fill: "#C5CCFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 68 126)",
    fill: "#C5CCFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 79 134)",
    fill: "#C5CCFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 4,
    rx: 2,
    transform: "matrix(-1 0 0 1 79 142)",
    fill: "#C5CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2471 120.198V127.545C74.2471 128.221 74.7787 128.753 75.4554 128.753H82.8021C83.1162 128.753 83.4304 128.632 83.6479 128.39L110.038 102.025L100.975 92.9622L74.6096 119.328C74.3679 119.57 74.2471 119.86 74.2471 120.198ZM117.046 95.0163C117.989 94.0738 117.989 92.5513 117.046 91.6088L111.391 85.9538C110.449 85.0113 108.926 85.0113 107.984 85.9538L103.561 90.3763L112.624 99.4388L117.046 95.0163Z",
    fill: "#FFC93C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGuidance);
export default __webpack_public_path__ + "static/media/home_guidance.cc8a4ed1e7a2479ab84b7130fbde0c25.svg";
export { ForwardRef as ReactComponent };